import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { GoogleStaticMap } from '@/components/ui/maps/GoogleStaticMap';
import { Text } from '@/components/ui/text/Text';


interface MapPreviewModalProps {
  mapUrl: string | null;
  pointCount?: number;
  locationName?: string;
  locationAddress?: string | null;
}

export const MapPreviewModal: FC<MapPreviewModalProps> = ({
  mapUrl,
  pointCount,
  locationName,
  locationAddress,
}) => {
  const { t: translate } = useTranslation('checkInLocation');

  if (pointCount !== undefined && pointCount < 3) {
    return (
      <div className="flex items-center justify-center py-8 px-4">
        <Text variant="body-regular" className="text-center">
          {translate('geolocalizacion.previewModal.insufficientPoints', { count: pointCount })}
        </Text>
      </div>
    );
  }

  if (!mapUrl) {
    return (
      <div className="flex items-center justify-center py-8">
        <Text variant="body-regular">
          {translate('geolocalizacion.previewModal.noPoints')}
        </Text>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {locationName && (pointCount === undefined || (pointCount >= 3 && pointCount <= 4)) && (
        <div className="flex flex-col gap-1">
          <Text variant="subheader-medium">{locationName}</Text>
          {locationAddress && (
            <Text variant="body-regular" className="text-sm">
              {locationAddress}
            </Text>
          )}
        </div>
      )}
      <GoogleStaticMap
        mapUrl={mapUrl}
        style={{ width: '100%', height: 360 }}
        alt={translate('geolocalizacion.previewModal.title')}
        data-testid="map-preview-image"
      />
    </div>
  );
};
